import { Stack } from '@mui/material';
import React, { ReactNode } from 'react';
import { Virtuoso, VirtuosoProps } from 'react-virtuoso';

interface VirtualizedListProps<T> extends Omit<VirtuosoProps<T, unknown>, 'itemContent' | 'data'> {
  items: T[];
  renderItem: (index: number, item: T) => ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
}

export const VirtualizedList = <T extends any>({
  items,
  renderItem,
  header,
  footer,
  ...virtuosoProps
}: VirtualizedListProps<T>) => {
  return (
    <Stack height="100%" width="100%">
      <Virtuoso
        data={items}
        itemContent={renderItem}
        components={{
          Header: header ? () => <>{header}</> : undefined,
          Footer: footer ? () => <>{footer}</> : undefined,
        }}
        {...virtuosoProps}
      />
    </Stack>
  );
};
